import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, usePage, useResource, useStore, useTheme, useToast } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_SCRN_MGMT_SRCH, SG_SCRN_LIST, URLS } from "@/tz/go/egaz/osci/ptl/ptl/scrn/services/OsciScrnService";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const OSCI0104004Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const toast = useToast();
    const { theme } = useTheme();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });

    const form = {
        scrnMgmtSrch: useForm({ defaultSchema: SF_SCRN_MGMT_SRCH }),
    };

    const grid = {
        scrnList: useGrid({
            defaultSchema: SG_SCRN_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getScrnList: useFetch({
            api: (page = grid.scrnList.page, size = grid.scrnList.size) =>
                APIS.getScrnList(form.scrnMgmtSrch.getValues(), page, size),
            enabled:
                !comnUtils.isEmpty(form.scrnMgmtSrch.getValue("bsopClsfCd")) &&
                !comnUtils.isEmpty(form.scrnMgmtSrch.getValue("ptlTpCd")),
            key: [grid.scrnList.page, grid.scrnList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.scrnMgmtSrch.getValues(),
                    page: grid.scrnList.page,
                    size: grid.scrnList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // 조회가 실패하였습니다.
        }),
    };

    const handler = {
        onNewBtnClick: () => navigate(`${URLS.osci0104005s}`),
        onSearchBtnClick: () => {
            // form.scrnMgmtSrch.setValue("bsopClsfCd", "OSC");
            setStore(pgeUid, form.scrnMgmtSrch.getValues());
            form.scrnMgmtSrch.handleSubmit(
                () => {
                    grid.scrnList.setPage(0);
                    fetch.getScrnList.fetch(0);
                },
                () => toast.showToast({ type: "warning", content: "msg.osc.00194" }), // 조회 조건 필수 입력 항목을 입력하시기 바랍니다.
            )();
        },
        onClear: () => {
            form.scrnMgmtSrch.clearValues();
            form.scrnMgmtSrch.setValues({ bsopClsfCd: "OSC", ptlTpCd: "O" });
            grid.scrnList.getData().length > 0 && grid.scrnList.clearData();
        },
    };

    const render = {
        cell: {
            scrnId: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`${URLS.osci0104006s}/${rowValues.scrnId}`}>{value}</Link>;
            },
        },
    };

    useEffect(() => {
        // Service Category, Portal Type 은 고정값이므로 수정할 수 없도록 한다.
        form.scrnMgmtSrch.setEditable("bsopClsfCd", false);
        form.scrnMgmtSrch.setEditable("ptlTpCd", false);

        const store = getStore(pgeUid);
        if (!comnUtils.isEmpty(store) && form.scrnMgmtSrch) {
            form.scrnMgmtSrch.setValues(store.form);
            fetch.getScrnList.fetch();
        }
    }, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmtSrch.schema.bsopClsfCd} />
                            <Group.Control {...form.scrnMgmtSrch.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.scrnMgmtSrch.schema.scrnId} />
                            <Group.Control {...form.scrnMgmtSrch.schema.scrnNm} />
                        </Group.Row>
                    </Group.Section>

                    <Layout>
                        <Layout.Left>
                            <Layout.Button role={"reset"} onClick={handler.onClear} />
                        </Layout.Left>
                        <Layout.Right>
                            <Layout.Button role={"search"} onClick={handler.onSearchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={"T_SCRN_LIST"} />
                    <Group.Section>
                        <Grid {...grid.scrnList.grid} data={fetch.getScrnList.data?.scrnList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout>
                <Layout.Left>
                    <Layout.Button role={"new"} onClick={handler.onNewBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
